import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const location = useLocation();

  return (
    <nav className="bg-[#1A365D] text-white py-4 fixed w-full z-50">
      <div className="container mx-auto px-4 flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold" aria-label="Perspectiva Data - Página de inicio">Perspectiva Data</Link>
        </div>
        
        {/* Mobile menu button */}
        <div className="md:hidden">
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-white focus:outline-none"
            aria-label={isMenuOpen ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {/* Desktop menu */}
        <div className="hidden md:flex space-x-8">
          <Link 
            to="/servicios" 
            className={`hover:text-[#4A90E2] transition-colors ${location.pathname === '/servicios' ? 'text-[#4A90E2] font-semibold' : ''}`}
            aria-current={location.pathname === '/servicios' ? 'page' : undefined}
          >
            Servicios
          </Link>
          <Link 
            to="/recursos" 
            className={`hover:text-[#4A90E2] transition-colors ${location.pathname === '/recursos' ? 'text-[#4A90E2] font-semibold' : ''}`}
            aria-current={location.pathname === '/recursos' ? 'page' : undefined}
          >
            Recursos
          </Link>
          <Link 
            to="/contacto" 
            className={`hover:text-[#4A90E2] transition-colors ${location.pathname === '/contacto' ? 'text-[#4A90E2] font-semibold' : ''}`}
            aria-current={location.pathname === '/contacto' ? 'page' : undefined}
          >
            Contacto
          </Link>
          <a 
            href="https://calendly.com/your-calendly-link" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="bg-[#27AE60] px-4 py-2 rounded-md hover:bg-[#219653] transition-colors"
            aria-label="Agendar una cita de consultoría"
          >
            Agendar Cita
          </a>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-[#1A365D] p-4 shadow-lg">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/servicios" 
                className={`hover:text-[#4A90E2] transition-colors py-2 ${location.pathname === '/servicios' ? 'text-[#4A90E2] font-semibold' : ''}`}
                onClick={() => setIsMenuOpen(false)}
                aria-current={location.pathname === '/servicios' ? 'page' : undefined}
              >
                Servicios
              </Link>
              <Link 
                to="/recursos" 
                className={`hover:text-[#4A90E2] transition-colors py-2 ${location.pathname === '/recursos' ? 'text-[#4A90E2] font-semibold' : ''}`}
                onClick={() => setIsMenuOpen(false)}
                aria-current={location.pathname === '/recursos' ? 'page' : undefined}
              >
                Recursos
              </Link>
              <Link 
                to="/contacto" 
                className={`hover:text-[#4A90E2] transition-colors py-2 ${location.pathname === '/contacto' ? 'text-[#4A90E2] font-semibold' : ''}`}
                onClick={() => setIsMenuOpen(false)}
                aria-current={location.pathname === '/contacto' ? 'page' : undefined}
              >
                Contacto
              </Link>
              <a 
                href="https://calendly.com/your-calendly-link" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-[#27AE60] px-4 py-2 rounded-md hover:bg-[#219653] transition-colors text-center"
                aria-label="Agendar una cita de consultoría"
              >
                Agendar Cita
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;